module.exports = __webpack_public_path__ + "img/cover-1.c5078c28.png";